/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { ApiKeys } from "App/IOC/Services";

export default {
    List: ApiKeys.List,
    Read: ApiKeys.Read,
    Generate: ApiKeys.Generate,
    Revoke: ApiKeys.Revoke
};
